import React from 'react'

import { usePSNavigate } from '../../hooks/usePSNavigate'
import { BaseRecord } from '../../models/BaseRecord'
import { ComputeFactory } from '../../models/ComputeFactory'
import { Item } from '../../models/Item'
import { RecordFactory } from '../../models/RecordFactory'
import { RecordNotFoundError } from '../../models/errors/RecordNotFoundError'
import { ComponentData } from '../../utils/typing'
import { PocketComponent, PocketComponentProps, usePSComponent } from '../PocketComponent'
import { AppHeader } from '../app/AppHeader'
import { PSButtonPrimary } from '../app/PSButton'
import { AdjustmentCard } from './AdjustmentCard'

const viewWillAppear = async ({ locationState }: PocketComponent<void>) => {
    const item = locationState.item
        ? BaseRecord.fromSerializer(locationState.item, Item)
        : undefined
    if (!item) {
        return new RecordNotFoundError()
    }

    await RecordFactory.getInstance().fetchAdjustmentHistory(item)
    const adjustmentList = await ComputeFactory.getInstance().fetchAdjustmentHistory(item)

    return { item, adjustmentList }
}

const render = ({ data }: PocketComponentProps<ComponentData<typeof viewWillAppear>>) => {
    if (data instanceof RecordNotFoundError) {
        throw data
    }

    const { item, adjustmentList } = data

    const navigate = usePSNavigate()

    return (
        <AppHeader title="Inventory" showBackButton={true} middleWidget={null}>
            <div className="pageWrapper">
                <div className="dashboardDetails">
                    <div className="header">
                        <h2>Change History</h2>
                        <PSButtonPrimary
                            className="actionButton"
                            onClick={() => navigate(`/inventory/${item.id}/new`)}
                        >
                            Change quantity
                        </PSButtonPrimary>
                    </div>
                    <div className="separator" />
                    <div className="list">
                        {adjustmentList.length === 0 ? (
                            <div className="empty">
                                <p>This product has</p>
                                <p style={{ fontWeight: 700, padding: '8px 0' }}>
                                    No history changes
                                </p>
                                <PSButtonPrimary
                                    className="actionButton"
                                    onClick={() => navigate(`/inventory/${item.id}/new`)}
                                >
                                    Change quantity
                                </PSButtonPrimary>
                            </div>
                        ) : (
                            adjustmentList.map((result, index) => (
                                <AdjustmentCard record={result} key={result.id ?? index} />
                            ))
                        )}
                    </div>
                </div>
            </div>
        </AppHeader>
    )
}
export const AdjustmentHistoryPage = usePSComponent(render, viewWillAppear)
